/**
 * My Downloads — Diary door (HARD LOCK mobile download)
 * Staging · /pages/my-downloads
 */
(() => {
  const root = document.getElementById("kl-photoset-downloads");
  if (!root || root.dataset.booted) return;
  root.dataset.booted = "1";

  const list = root.querySelector("[data-dl-list]");
  const empty = root.querySelector("[data-dl-empty]");
  const toastEl = root.querySelector("[data-dl-toast]");
  const inAppTip = root.querySelector("[data-dl-inapp]");
  const loginUrl = root.dataset.loginUrl || "/account/login";
  const downloadsUrl = root.dataset.downloadsUrl || "/apps/katiecoins/downloads";
  const studioUrl = root.dataset.studioUrl || "/pages/photoset-studio";
  const isLoggedIn = root.dataset.loggedIn === "1";

  let toastTimer = null;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toastEl.hidden = true; }, 3000);
  }
  function esc(s) {
    return String(s ?? "").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");
  }
  function cleanTitle(t) {
    return String(t ?? "").replace(/\u2014|\u2013/g, " ").replace(/\s{2,}/g, " ").trim();
  }
  function isInAppBrowser() {
    const ua = navigator.userAgent || "";
    return /FBAN|FBAV|Instagram|Line\/|Twitter|LinkedInApp|Snapchat|Pinterest|TikTok|MicroMessenger|WhatsApp/i.test(ua);
  }
  if (inAppTip && isInAppBrowser()) inAppTip.hidden = false;

  if (!isLoggedIn) {
    if (empty) {
      empty.hidden = false;
      empty.innerHTML = `Sign in to see photosets you've redeemed. <a href="${esc(loginUrl)}">Sign in</a>`;
    }
    if (list) list.innerHTML = "";
    return;
  }

  function rowHtml(item) {
    const thumb = item.preview_url
      ? `<img class="kl-dl-thumb" src="${esc(item.preview_url)}" alt="" loading="lazy" />`
      : `<div class="kl-dl-thumb-fallback">♡</div>`;
    return `
      <article class="kl-dl-row" data-set-id="${esc(item.set_id)}">
        ${thumb}
        <div class="kl-dl-meta">
          <h2 class="kl-dl-title">${esc(cleanTitle(item.title))}</h2>
          <p class="kl-dl-sub">Redeemed ${esc((item.created_at || "").slice(0, 10))}${item.spicy ? " · Spicy" : ""}${item.zip_size ? ` · ${esc(item.zip_size)}` : ""}</p>
        </div>
        <button type="button" class="kl-ps-btn kl-ps-btn-download" data-download="${esc(item.set_id)}">Download</button>
      </article>`;
  }

  async function load() {
    try {
      const res = await fetch(`${downloadsUrl}?mint=0`, { credentials: "same-origin" });
      if (res.status === 401) {
        window.location.href = loginUrl;
        return;
      }
      const data = await res.json();
      const items = data.items || [];
      if (!items.length) {
        if (empty) {
          empty.hidden = false;
          empty.innerHTML = `No photosets yet — visit <a href="${esc(studioUrl)}">KatieCoin Purse & Redeem</a> to browse and redeem KatieCoins.`;
        }
        if (list) list.innerHTML = "";
        return;
      }
      if (empty) empty.hidden = true;
      if (list) list.innerHTML = items.map(rowHtml).join("");
    } catch (err) {
      if (empty) {
        empty.hidden = false;
        empty.textContent = String(err.message || err);
      }
    }
  }

  async function doDownload(setId) {
    if (isInAppBrowser()) {
      toast("Open in Safari or Chrome to save the zip.");
      return;
    }
    try {
      const res = await fetch(`${downloadsUrl}?set_id=${encodeURIComponent(setId)}`, {
        credentials: "same-origin",
      });
      const data = await res.json().catch(() => ({}));
      const item = (data.items || [])[0];
      if (item?.r2_pending || item?.mint_error === "r2_pending") {
        toast("Download pending — Media is wiring the zip bucket.");
        return;
      }
      if (item?.download_url) {
        toast("Saved to Files — open anytime.");
        window.location.href = item.download_url;
        return;
      }
      toast(item?.mint_error || data.error || "Could not mint download link.");
    } catch (err) {
      toast(String(err.message || err));
    }
  }

  list?.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-download]");
    if (btn) doDownload(btn.getAttribute("data-download"));
  });

  load();
})();
